<template>
  <div class="page">
    <PageHeader
      title="계정 세팅 / 전달"
      subtitle="유료(USER) 학교의 비밀번호 설정, 방학중지 처리를 한 화면에서 처리합니다."
      :breadcrumb="breadcrumb"
    />

    <div class="page__sections">
      <AccountPassword />
      <VacationStop />
    </div>
  </div>
</template>

<script setup>
import PageHeader from "@/components/ui/PageHeader.vue";
import AccountPassword from "./AccountPasswordComponent.vue";
import VacationStop from "./VacationStopComponent.vue";

const breadcrumb = [
  { label: "USER 계정관리" },
  { label: "계정 세팅 / 전달" },
];
</script>

<style scoped>
.page {
  padding: var(--space-8);
  max-width: 1400px;
  margin: 0 auto;
}

.page__sections {
  display: flex;
  flex-direction: column;
  gap: var(--space-6);
}
</style>
